module.exports = __webpack_public_path__ + "static/img/8.732d6f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/3/zh/8.png
// module id = CAF6
// module chunks = 0